import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { makeStyles } from '@material-ui/core/styles';
import {AppBar,Toolbar, Button} from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CollapsedNavBar from './CollapsedNavBar';
import logo from '../assets/logo.svg';

const useStyles =  makeStyles((theme) => ({

  btngrp:{
    marginTop:'7px',
    fontFamily:['Nunito'].join(','),
    textTransform:'none',
    marginRight:'3%',
    marginLeft:'3%',
    color: '#4F5052',
    '&:hover': {
      borderBottom: '5px solid #A8DBEF',
      backgroundColor:'white',
      borderRadius:'0px'
    }
  },

  logoutbtn:{
    marginTop:'7px',
    fontFamily:['Nunito'].join(','),
    textTransform:'none',
    marginRight:'3%',
    marginLeft:'3%',
    color: '#153BAB',
    '&:hover': {
      borderBottom: '5px solid #A8DBEF',
      backgroundColor:'white',
      borderRadius:'0px'
    }
  },

  AppBarStyle: {
    backgroundColor: 'white',
    color: 'black',
    zIndex: '1000',
  },

  logoImg: {
    marginTop:'10px',
    flexGrow: 1,
    marginLeft:'50px',
    '@media (max-width: 880px)': {
          marginLeft: '5px'
        }
  },
}));

const NavBar = (props) =>{
  const { isAuthenticated, logout } = useAuth0();
  let matches = useMediaQuery('(max-width:880px)');
  const classes = useStyles();
  const type = props.type;
  // navItems will be passed as a props to the collapsed bar
  var navItems = [];
  // navItems External links 
  // need to be passed to the collapsed nav 
  var navItemsExtLinks = []

  if (type === 'main') { // main nav bar
    if (matches ===true) // if window size is small
    {
        navItems = [
          {
            text: ' ',
            link: ' '
          },
          // {
          //   text: 'About',
          //   link: '/about'
          // },
          // {
          //   text: 'Resources',
          //   link: '/worldclassai'
          // },
          // {
          //   text: 'Blog',
          //   link: '/'
          // }
        ];

        navItemsExtLinks = [
          {
            text: ' ',
            link: ' '
          },
          {
            text: 'Book free Consultation', 
            link: 'https://calendly.com/marc-banoub'
          }
        ]

        return (
        <AppBar className={classes.AppBarStyle} position="relative">
            <Toolbar>
            <div className={classes.logoImg}>
            <Link to={{ pathname: "/" }} >
            <img src={logo}  alt="logo"/>
            </Link>
            </div>
            <CollapsedNavBar navItems={navItems} extLinks={navItemsExtLinks}/>
            { isAuthenticated && 
            <Button 
            className={classes.logoutbtn}  
            onClick={() => logout({ returnTo: window.location.origin })}>
              <strong style={{ fontSize: '18px' }}>Logout</strong>
            </Button>
            }
            </Toolbar>
        </AppBar>
        );
    }
    
    return (
        <AppBar className={classes.AppBarStyle} position="relative">
        <Toolbar>
            <div className={classes.logoImg}>
            <Link to={{ pathname: "/" }} >

            <img src={logo}  alt="logo"/>
            </Link>

            </div>
            
            {/* <Button 
            className={classes.btngrp} 
            component={Link} to={'/About'}>
            About</Button>

            <Button 
            className={classes.btngrp}  
            component={Link} to={'/worldclassai'}>
                Resources</Button>
            
            <Button 
            className={classes.btngrp}  
            component={Link} to={'/'}>
                blog</Button>
             */}
            <Button 
            className={classes.btngrp}  
            target='_blank' 
            href='https://calendly.com/marc-banoub'>
                <strong>Book free Consultation</strong></Button>
            
            { isAuthenticated && 
            <Button 
            className={classes.logoutbtn}  
            onClick={() => logout({ returnTo: window.location.origin })}>
              <strong style={{ fontSize: '18px' }}>Logout</strong>
            </Button>
            }
        </Toolbar>
        </AppBar>
    );
  }
  if (type === 'exam'){
    if (matches ===true) // if window size is small
    {

      navItems=[' ','Assessment', 'Performance', 'Profile'];
      return (
        <AppBar className={classes.AppBarStyle} position="relative">
          <Toolbar>
            <div className={classes.logoImg}>
            <img src={logo}  alt="logo"/>
            </div>
            <CollapsedNavBar navItems={navItems}/>
          </Toolbar>
        </AppBar>
      );
    }
      return (

        <AppBar className={classes.AppBarStyle} position="relative">
          <Toolbar>
            <div className={classes.logoImg}>
            <img src={logo}  alt="logo"/>
            </div>
            <Button className={classes.btngrp}><strong>Assessment</strong></Button>
            <Button className={classes.btngrp}><strong>Performance</strong></Button>
            <Button className={classes.btngrp}><strong>Profile</strong></Button>
          </Toolbar>
        </AppBar>
      );
  }
};

export default (NavBar);
